import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import {
  BEGIN, CREATE, FAILED, SUCCESSFUL, UPDATE,
} from '../../configs/actionNames';
import { SETTINGS_MODULE } from '../../configs/moduleNames';

export const LOAD_SETTINGS_LIST = '_LOAD_SETTINGS_LIST';
export const LOAD_SETTINGS_BY_ID = '_LOAD_SETTINGS_BY_ID';
export const LOAD_SETTINGS_ENUM_LIMITED = '_LOAD_SETTINGS_ENUM_LIMITED';
export const DELETE_SETTINGS = '_DELETE_SETTINGS';

export const loadSettingsList = createDeferredAction(SETTINGS_MODULE + LOAD_SETTINGS_LIST);
export const loadSettingsListSuccessful = createAction(SETTINGS_MODULE + LOAD_SETTINGS_LIST + SUCCESSFUL);
export const loadSettingsListFailed = createAction(SETTINGS_MODULE + LOAD_SETTINGS_LIST + FAILED);

export const loadSettingsById = createDeferredAction(SETTINGS_MODULE + LOAD_SETTINGS_BY_ID);
export const loadSettingsByIdSuccessful = createAction(SETTINGS_MODULE + LOAD_SETTINGS_BY_ID + SUCCESSFUL);
export const loadSettingsByIdFailed = createAction(SETTINGS_MODULE + LOAD_SETTINGS_BY_ID + FAILED);
export const loadSettingsByIdBegin = createAction(SETTINGS_MODULE + LOAD_SETTINGS_BY_ID + BEGIN);

export const deleteSettings = createDeferredAction(SETTINGS_MODULE + DELETE_SETTINGS);
export const deleteSettingsSuccessful = createAction(SETTINGS_MODULE + DELETE_SETTINGS + SUCCESSFUL);
export const deleteSettingsFailed = createAction(SETTINGS_MODULE + DELETE_SETTINGS + FAILED);

export const createSetting = createDeferredAction(SETTINGS_MODULE + CREATE);
export const createSettingSuccessful = createAction(SETTINGS_MODULE + CREATE + SUCCESSFUL);
export const createSettingFailed = createAction(SETTINGS_MODULE + CREATE + FAILED);

export const editSetting = createDeferredAction(SETTINGS_MODULE + UPDATE);
export const editSettingSuccessful = createAction(SETTINGS_MODULE + UPDATE + SUCCESSFUL);
export const editSettingFailed = createAction(SETTINGS_MODULE + UPDATE + FAILED);

export const loadSettingEnumLimited = createDeferredAction(SETTINGS_MODULE + LOAD_SETTINGS_ENUM_LIMITED);
export const loadSettingEnumLimitedSuccessful = createAction(SETTINGS_MODULE + LOAD_SETTINGS_ENUM_LIMITED + SUCCESSFUL);
export const loadSettingEnumLimitedFailed = createAction(SETTINGS_MODULE + LOAD_SETTINGS_ENUM_LIMITED + FAILED);
